import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import GameMaster from "@/pages/GameMaster";
import TeamDisplay from "@/pages/TeamDisplay";
import Presentation from "@/pages/Presentation";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/presentation" element={<Presentation />} />
          <Route path="/game-master/:gameId" element={<GameMaster />} />
          <Route path="/display/:gameId" element={<TeamDisplay />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
